import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../parts/SvgIcon";
import { getPlanTrainingCardContent } from "../../../../../utils/plan-training-helpers";

function PlanTrainingCard({ exercises, cycles = [] }) {
  const { t } = useTranslation("athlete-portal");
  const content = useMemo(
    () => getPlanTrainingCardContent(exercises, cycles),
    [exercises, cycles]
  );

  if (content.variant === "rest") {
    return (
      <div className="plan-card plan-card--training plan-card--rest">
        <div className="plan-card__header">
          <SvgIcon src="/img/new-icons/barbell.svg" useCurrentColor={true} />
          <span className="plan-card__label">
            {t("calendar.cards.training.restDay")}
          </span>
        </div>
      </div>
    );
  }

  const detailLines =
    content.variant === "custom"
      ? [t("calendar.cards.training.customWorkout")]
      : [
          content.programName,
          content.blockName,
          content.workoutName
            ? t("calendar.cards.training.workoutDayWeek", {
                workoutName: content.workoutName,
                day: content.programSession,
                week: content.programWeek,
              })
            : t("calendar.cards.training.dayWeekFallback", {
                day: content.programSession,
                week: content.programWeek,
              }),
        ].filter(Boolean);

  return (
    <div className="plan-card plan-card--training">
      <div className="plan-card__header">
        <SvgIcon src="/img/new-icons/barbell.svg" useCurrentColor={true} />
        {t("calendar.cards.training.title")}
      </div>
      {detailLines.length > 0 && (
        <div className="plan-card__body">
          {detailLines.map((line, index) => (
            <div key={`${index}-${line}`} className="plan-card__detail-line">
              {line}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default PlanTrainingCard;
